import { AppHeaderMenuButton } from "@comet/admin";
import { Menu as MenuIcon, PowerSettingsNew } from "@mui/icons-material";
import LockIcon from "@mui/icons-material/Lock";
import { AppBar, Grid } from "@mui/material";
import config from "@src/config";
import logo from "@src/images/logo.svg";
import { UserContext, useUser } from "@vivid/react-oidc-client";
import { useContext } from "react";
import { FormattedMessage } from "react-intl";

import { HeaderButton, Logo, StyledDivider, UserName } from "./MasterHeader.sc";

export function MasterHeader() {
    const userContext = useContext(UserContext);
    // TODO use when fixed in comet-admin
    //const { headerHeight } = useContext(MasterLayoutContext);

    const user = useUser();
    return (
        <AppBar style={{ height: 60 }}>
            <Grid container justifyContent="space-between" alignItems="center" sx={{ height: "100%", paddingX: 1 }}>
                <Grid>
                    <Grid container spacing={2} alignItems="center">
                        <Grid>
                            <AppHeaderMenuButton>
                                <MenuIcon />
                            </AppHeaderMenuButton>
                        </Grid>
                        <Grid>
                            <Logo>
                                <use xlinkHref={`${logo}#logo`} />
                            </Logo>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid>
                    <Grid container spacing={2} alignItems="center">
                        <Grid>
                            <UserName>{user?.name}</UserName>
                        </Grid>
                        <Grid>
                            <HeaderButton
                                startIcon={<LockIcon />}
                                onClick={() => {
                                    userContext.signIn({
                                        extraQueryParams: {
                                            acr_values: "password_change",
                                            id_token_hint: userContext.getUser().id_token,
                                            return_url: config.ADMIN_URL,
                                        },
                                    });
                                }}
                            >
                                <FormattedMessage id="reviermanager.user.changePassword" defaultMessage="Passwort ändern" />
                            </HeaderButton>
                        </Grid>
                        <Grid>
                            <StyledDivider orientation="vertical" />
                        </Grid>
                        <Grid>
                            <HeaderButton
                                startIcon={<PowerSettingsNew />}
                                onClick={() => {
                                    userContext.signOut();
                                }}
                                variant="text"
                            >
                                <FormattedMessage id="reviermanager.user.logout" defaultMessage="Logout" />
                            </HeaderButton>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </AppBar>
    );
}
